/* eslint-disable jsdoc/require-returns */
/*
 * @Author: Nora Galvin
 * @Date: 2020-08-19 15:54:48
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-25 14:15:14
 */

type TypeDefaultJSON = {
  animations: any[];
  actions: any[];
  events: any[];
};

/**
 * Content BK Interaction template
 * Shark updated => next version need to be re-folder this file
 * @param root0 ..
 * @param root0.animation ..
 * @param root0.action ..
 * @param root0.event ..
 * @returns string
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default ({ animation, action, event }: any): TypeDefaultJSON => {
  const defaultJSON: TypeDefaultJSON = {
    animations: [],
    actions: [],
    events: [],
  };

  if (animation) {
    defaultJSON.animations.push(animation);
  }

  if (action) {
    defaultJSON.actions.push(action);
  }

  if (event) {
    defaultJSON.events.push(event);
  }
  return defaultJSON;
};
